import React from "react";
import { Link, useParams } from "react-router-dom";

const Invoice = () => {
  const { orderId } = useParams();

  const customerInfo = {
    name: "Clement Atangana",
    address: "4350 Whitetail Lane, Dallas, Texas, 75202 Lomé",
    phone: "+1 (460) 227 9044"
  };

  const billingInfo = {
    billTo: {
      name: "Clement Atangana",
      address: "U2186 Joyce Street Rocky Mount",
      city: "California - 24567, USA"
    },
    shipTo: {
      name: "Travis Adams",
      address: "U2186 Joyce Street Rocky Mount",
      city: "California - 24567, USA"
    }
  };

  const invoiceDetails = {
    invoiceId: "#OD24321",
    shippingId: "#012022311P",
    date: "14/01/2024, 10:14"
  };

  const products = [
    {
      id: 1,
      name: "Ipol Pro S6 5G",
      sku: "JL29301911300",
      image: "/images/app.png",
      price: 450.00,
      quantity: 1,
      total: 67500
    },
    {
      id: 2,
      name: "TWS Earphone M1",
      sku: "J129381911300",
      image: "/images/ecouteur.png",
      price: 100.00,
      quantity: 1,
      total: 25000
    },
    {
      id: 3,
      name: "Earphone G1",
      sku: "JL29381911350",
      image: "/images/ecouteur.png",
      price: 145.00,
      quantity: 1,
      total: 5000
    }
  ];

  const financialSummary = {
    subtotal: 97500,
    discount: 0,
    shipping: 5000,
    tax: 5000,
    total: 196000
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Facture
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <Link to="/dashboard/orders" className="text-orange-500 hover:text-orange-600">
              Commandes
            </Link>
            <span className="mx-2">{'>'}</span>
            <Link to={`/dashboard/orders/${orderId || 'OD24321'}`} className="text-orange-500 hover:text-orange-600">
              Detail Commande
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>Facture</span>
          </div>
        </div>
        
        {/* Print Button */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
          </svg>
          Imprimer
        </button>
      </div>

      {/* Main Content - Two Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Left Column - Invoice Content */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            {/* Customer Information */}
            <div className="flex items-start gap-4 mb-8">
              <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">{customerInfo.name}</h2>
                <p className="text-gray-600 mt-1">{customerInfo.address}</p>
                <p className="text-gray-600">{customerInfo.phone}</p>
              </div>
            </div>

            {/* Billing and Shipping Details */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              {/* Bill To */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Facturer à</h3>
                <div className="space-y-2">
                  <p className="text-gray-900">{billingInfo.billTo.name}</p>
                  <p className="text-gray-600">{billingInfo.billTo.address}</p>
                  <p className="text-gray-600">{billingInfo.billTo.city}</p>
                </div>
              </div>

              {/* Ship To */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Envoyez à</h3>
                <div className="space-y-2">
                  <p className="text-gray-900">{billingInfo.shipTo.name}</p>
                  <p className="text-gray-600">{billingInfo.shipTo.address}</p>
                  <p className="text-gray-600">{billingInfo.shipTo.city}</p>
                </div>
              </div>

              <div className="">
              {/* <div></div> */}
              <div className="text-right space-y-2">
                <div className="flex justify-between gap-4">
                  <span className="text-gray-600">ID de facture:</span>
                  <span className="text-gray-900 font-medium">{invoiceDetails.invoiceId}</span>
                </div>
                <div className="flex justify-between gap-4">
                  <span className="text-gray-600">ID d'expédition:</span>
                  <span className="text-gray-900 font-medium">{invoiceDetails.shippingId}</span>
                </div>
                <div className="flex justify-between gap-4">
                  <span className="text-gray-600">Date:</span>
                  <span className="text-gray-900 font-medium">{invoiceDetails.date}</span>
                </div>
              </div>
            </div>
            </div>

            {/* Products Table */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">Produit</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">Prix</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">Qté</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">Total</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {products.map((product) => (
                    <tr key={product.id}>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-gray-300 rounded flex items-center justify-center">
                            <img src={product.image} alt={product.name} className="w-6 h-6 object-cover rounded" />
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">{product.name}</p>
                            <p className="text-xs text-gray-500">SKU: {product.sku}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <p className="text-sm text-gray-900">${product.price.toFixed(2)}</p>
                      </td>
                      <td className="px-4 py-4">
                        <p className="text-sm text-gray-900">{product.quantity}</p>
                      </td>
                      <td className="px-4 py-4">
                        <p className="text-sm font-medium text-gray-900">{product.total.toLocaleString()} FCFA</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Financial Summary */}
            <div className="mt-8 flex justify-end">
              <div className="w-64 space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Subtotal</span>
                  <span className="text-gray-900">{financialSummary.subtotal.toLocaleString()} FCFA</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Rabais</span>
                  <span className="text-gray-900">{financialSummary.discount.toLocaleString()} FCFA</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Expédition</span>
                  <span className="text-gray-900">{financialSummary.shipping.toLocaleString()} FCFA</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Tax (5%)</span>
                  <span className="text-gray-900">{financialSummary.tax.toLocaleString()} FCFA</span>
                </div>
                <div className="border-t border-gray-200 pt-3">
                  <div className="flex justify-between">
                    <span className="text-lg font-bold text-gray-900">Total</span>
                    <span className="text-lg font-bold text-gray-900">{financialSummary.total.toLocaleString()} FCFA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Action Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-6">Facture</h3>
            
            <div className="space-y-4">
              {/* Send Invoice */}
              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
                Envoyer la facture
              </button>

              {/* Download Invoice */}
              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Télécharger la facture
              </button>

              {/* Print Invoice */}
              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                Imprimer la facture
              </button>

              {/* Edit Invoice */}
              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Modifier la facture
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
